module.exports = __webpack_public_path__ + "img/instagram@2x.71281318.png";